import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const LastPaybackStillProcessing = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('LastPaybackStillProcessing.title')}>
      <p>{t('LastPaybackStillProcessing.info')}</p>

      <ModalActions>
        <Button onClick={closeModal}>{t('LastPaybackStillProcessing.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default LastPaybackStillProcessing;
